import { render, staticRenderFns } from "./ResearchScriptsForm.vue?vue&type=template&id=295b41ec&scoped=true&"
import script from "./ResearchScriptsForm.vue?vue&type=script&lang=js&"
export * from "./ResearchScriptsForm.vue?vue&type=script&lang=js&"
import style0 from "./ResearchScriptsForm.vue?vue&type=style&index=0&id=295b41ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b41ec",
  null
  
)

export default component.exports